import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=04b1049e"
import script from "./ContentLayout.vue?vue&type=script&lang=ts"
export * from "./ContentLayout.vue?vue&type=script&lang=ts"
import style0 from "./ContentLayout.vue?vue&type=style&index=0&id=04b1049e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports